import React from 'react';
import { ShieldIcon, TrophyIcon, FlameIcon, CheckIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function RacingClasses() {
  const {
    t
  } = useLanguage();
  return <section id="classes" className="w-full bg-neutral-950 bg-noise py-20 md:py-28 px-4" data-id="element-445">
      <div className="max-w-7xl mx-auto" data-id="element-446">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-447">
          <p className="text-orange-500 font-semibold text-sm uppercase tracking-[0.3em] mb-3" data-id="element-448">
            {t('classes.chooseChallenge')}
          </p>
          <h2 className="font-display text-4xl md:text-6xl tracking-wider text-white mb-4" data-id="element-449">
            {t('classes.title')}
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-450">
            {t('classes.subtitle')}
          </p>
        </div>

        {/* Classes Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8" data-id="element-451">
          {/* Beginner Class */}
          <div className="relative group bg-neutral-900 border border-neutral-800 rounded-2xl overflow-hidden hover:border-green-500/50 transition-all duration-300" data-id="element-452">
            <div className="absolute top-0 left-0 right-0 h-1 bg-green-500" aria-hidden="true" data-id="element-453" />
            <div className="p-8" data-id="element-454">
              <div className="w-14 h-14 rounded-xl bg-green-500/10 flex items-center justify-center mb-6" data-id="element-455">
                <ShieldIcon className="h-7 w-7 text-green-500" data-id="element-456" />
              </div>
              <h3 className="font-display text-3xl tracking-wider text-white mb-2" data-id="element-457">
                {t('classes.beginner')}
              </h3>
              <p className="text-gray-400 mb-6" data-id="element-458">{t('classes.beginnerDesc')}</p>

              {/* Price */}
              <div className="mb-6" data-id="element-459">
                <span className="text-4xl font-bold text-white" data-id="element-460">€100</span>
                <span className="text-gray-500 ml-2" data-id="element-461">
                  {t('classes.perRider')}
                </span>
                <p className="text-green-500 text-sm font-semibold mt-1" data-id="element-462">
                  {t('classes.earlyBird')}
                </p>
              </div>

              {/* Requirements */}
              <div className="space-y-3 mb-8" data-id="element-463">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-464">
                  {t('classes.requirements')}
                </p>
                <div className="flex items-start gap-3" data-id="element-465"></div>
                <div className="flex items-start gap-3" data-id="element-466">
                  <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-467" />
                  <span className="text-gray-300 text-sm" data-id="element-468">
                    {t('classes.beginnerReq1')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-469">
                  <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-470" />
                  <span className="text-gray-300 text-sm" data-id="element-471">
                    {t('classes.beginnerReq2')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-472">
                  <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-473" />
                  <span className="text-gray-300 text-sm" data-id="element-474">
                    {t('classes.beginnerReq3')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-475">
                  <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-476" />
                  <span className="text-gray-300 text-sm" data-id="element-477">
                    {t('classes.beginnerReq4')}
                  </span>
                </div>
              </div>

              {/* Details */}
              <div className="bg-neutral-800/50 rounded-xl p-4 mb-4" data-id="element-478">
                <div className="grid grid-cols-2 gap-4 text-center" data-id="element-479">
                  <div data-id="element-480">
                    <p className="text-2xl font-bold text-white" data-id="element-481">10 km</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-482">
                      {t('classes.distance')}
                    </p>
                  </div>
                  <div data-id="element-483">
                    <p className="text-2xl font-bold text-white" data-id="element-484">3 st.</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-485">
                      {t('classes.timeLimit')}
                    </p>
                  </div>
                </div>
              </div>
              <p className="text-xs text-gray-500 italic" data-id="element-486">
                {t('classes.scoringRule')}
              </p>
            </div>
          </div>

          {/* Hobby Class */}
          <div className="relative group bg-neutral-900 border border-neutral-800 rounded-2xl overflow-hidden hover:border-orange-500/50 transition-all duration-300 md:scale-105 md:shadow-2xl" data-id="element-487">
            <div className="absolute top-0 left-0 right-0 h-1 bg-orange-500" aria-hidden="true" data-id="element-488" />
            <div className="absolute top-4 right-4" data-id="element-489">
              <span className="px-3 py-1 bg-orange-500 text-black text-xs font-bold uppercase rounded-full" data-id="element-490">
                {t('classes.popular')}
              </span>
            </div>
            <div className="p-8" data-id="element-491">
              <div className="w-14 h-14 rounded-xl bg-orange-500/10 flex items-center justify-center mb-6" data-id="element-492">
                <TrophyIcon className="h-7 w-7 text-orange-500" data-id="element-493" />
              </div>
              <h3 className="font-display text-3xl tracking-wider text-white mb-2" data-id="element-494">
                {t('classes.hobby')}
              </h3>
              <p className="text-gray-400 mb-6" data-id="element-495">{t('classes.hobbyDesc')}</p>

              {/* Price */}
              <div className="mb-6" data-id="element-496">
                <span className="text-4xl font-bold text-white" data-id="element-497">€100</span>
                <span className="text-gray-500 ml-2" data-id="element-498">
                  {t('classes.perRider')}
                </span>
                <p className="text-green-500 text-sm font-semibold mt-1" data-id="element-499">
                  {t('classes.earlyBird')}
                </p>
              </div>

              {/* Requirements */}
              <div className="space-y-3 mb-8" data-id="element-500">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-501">
                  {t('classes.requirements')}
                </p>
                <div className="flex items-start gap-3" data-id="element-502"></div>
                <div className="flex items-start gap-3" data-id="element-503">
                  <CheckIcon className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-504" />
                  <span className="text-gray-300 text-sm" data-id="element-505">
                    {t('classes.hobbyReq1')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-506">
                  <CheckIcon className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-507" />
                  <span className="text-gray-300 text-sm" data-id="element-508">
                    {t('classes.hobbyReq2')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-509">
                  <CheckIcon className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-510" />
                  <span className="text-gray-300 text-sm" data-id="element-511">
                    {t('classes.hobbyReq3')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-512">
                  <CheckIcon className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-513" />
                  <span className="text-gray-300 text-sm" data-id="element-514">
                    {t('classes.hobbyReq4')}
                  </span>
                </div>
              </div>

              {/* Details */}
              <div className="bg-neutral-800/50 rounded-xl p-4 mb-4" data-id="element-515">
                <div className="grid grid-cols-2 gap-4 text-center" data-id="element-516">
                  <div data-id="element-517">
                    <p className="text-2xl font-bold text-white" data-id="element-518">12 km</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-519">
                      {t('classes.distance')}
                    </p>
                  </div>
                  <div data-id="element-520">
                    <p className="text-2xl font-bold text-white" data-id="element-521">3 st.</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-522">
                      {t('classes.timeLimit')}
                    </p>
                  </div>
                </div>
              </div>
              <p className="text-xs text-gray-500 italic" data-id="element-523">
                {t('classes.scoringRule')}
              </p>
            </div>
          </div>

          {/* Pro Class */}
          <div className="relative group bg-neutral-900 border border-neutral-800 rounded-2xl overflow-hidden hover:border-red-500/50 transition-all duration-300" data-id="element-524">
            <div className="absolute top-0 left-0 right-0 h-1 bg-red-500" aria-hidden="true" data-id="element-525" />
            <div className="p-8" data-id="element-526">
              <div className="w-14 h-14 rounded-xl bg-red-500/10 flex items-center justify-center mb-6" data-id="element-527">
                <FlameIcon className="h-7 w-7 text-red-500" data-id="element-528" />
              </div>
              <h3 className="font-display text-3xl tracking-wider text-white mb-2" data-id="element-529">
                {t('classes.pro')}
              </h3>
              <p className="text-gray-400 mb-6" data-id="element-530">{t('classes.proDesc')}</p>

              {/* Price */}
              <div className="mb-6" data-id="element-531">
                <span className="text-4xl font-bold text-white" data-id="element-532">€100</span>
                <span className="text-gray-500 ml-2" data-id="element-533">
                  {t('classes.perRider')}
                </span>
                <p className="text-green-500 text-sm font-semibold mt-1" data-id="element-534">
                  {t('classes.earlyBird')}
                </p>
              </div>

              {/* Requirements */}
              <div className="space-y-3 mb-8" data-id="element-535">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-536">
                  {t('classes.requirements')}
                </p>
                <div className="flex items-start gap-3" data-id="element-537"></div>
                <div className="flex items-start gap-3" data-id="element-538">
                  <CheckIcon className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-539" />
                  <span className="text-gray-300 text-sm" data-id="element-540">
                    {t('classes.proReq1')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-541">
                  <CheckIcon className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-542" />
                  <span className="text-gray-300 text-sm" data-id="element-543">
                    {'Pilns sacens\u012Bbu ekip\u0113jums ar ieteicamu kakla aizsargu'}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-544">
                  <CheckIcon className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-545" />
                  <span className="text-gray-300 text-sm" data-id="element-546">
                    {t('classes.proReq3')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-547">
                  <CheckIcon className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-548" />
                  <span className="text-gray-300 text-sm" data-id="element-549">
                    {t('classes.proReq4')}
                  </span>
                </div>
              </div>

              {/* Details */}
              <div className="bg-neutral-800/50 rounded-xl p-4 mb-4" data-id="element-550">
                <div className="grid grid-cols-2 gap-4 text-center" data-id="element-551">
                  <div data-id="element-552">
                    <p className="text-2xl font-bold text-white" data-id="element-553">13 km</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-554">
                      {t('classes.distance')}
                    </p>
                  </div>
                  <div data-id="element-555">
                    <p className="text-2xl font-bold text-white" data-id="element-556">3 st.</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-557">
                      {t('classes.timeLimit')}
                    </p>
                  </div>
                </div>
              </div>
              <p className="text-xs text-gray-500 italic" data-id="element-558">
                {t('classes.scoringRule')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}